import React, {useEffect, useState} from 'react'
import {connect, useSelector} from "react-redux";
import {Col, Row, Spinner} from "reactstrap";

// components
import {GenericButton} from "../../../../components/buttons/customButtons";

// labels
import {
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setFilter,
    setForm,
    setItem
} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";
import {GenericContainer} from "../../../../components/containers/GenericContainer";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {  TT_REMOVE} from "../../../../components/i18n/toolTips";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {roomPlaceService} from "../../../../jwt/_services/hotel/roomPlaceService";
import {roomTypeProvider} from "../../../../providers/roomTypeProvider";


const SuitesSection = (props) => {
    const path = `${props.path}/suites`;
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const { udn, app, domainObject } = parentComponentState?.data || {};
    const {  listDomainObjects } = componentState?.data || [];
    const {  loading, filter } = componentState?.data || {};
    const [selectedSuite, setSelectedSuite] = useState(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if (!app || !domainObject?.id)
            return;

        props.setApp(path, app);

        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item: {
                place : { id : domainObject?.id }
            }
        });
    }, [ domainObject, app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, roomPlaceService, 0, 1000, filter)
    }, [ filter ]);

    const onLinkItem = () => {
        if(!selectedSuite) return;

        const requestData = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item:{
                place: {id: domainObject?.id},
                roomType: {id: selectedSuite},
                showOrder: (listDomainObjects?.length || 0)
            }
        }

        genericIndexedActions.save(path, roomPlaceService, requestData)
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        closeOnEscape: false,
        closeOnClickOutside: false,
        fbDataBaseId: app?.fbDataBase?.id,
        service: roomPlaceService,
        remove : genericIndexedActions.delete,
    } );

    const renderContent = (item, index) => <div key={index} className={'dnd-item'}>
        <Row>
            <Col className={'dnd-title'}>
                { item?.roomTypeCodeSynxis?.toUpperCase() + ' | ' + item?.roomTypeName }
            </Col>
            <Col>
                <div className={'actions'}>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => confirmDelete(item)}
                    />
                </div>
            </Col>
        </Row>
    </div>

    const onReorderItems = reorderProps => {
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps?.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem?.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = listDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject?.showOrder !== reorderedItem?.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, roomPlaceService, dataRequest)
    }

    return <>
        { loading ? <Spinner animation="border"/> :
            <GenericContainer
                titlle={'Suites'}
                listItems={listDomainObjects}
                renderContent={renderContent}

                provider={roomTypeProvider}
                option={selectedSuite}
                setOption={setSelectedSuite}
                providerFilter={{ fbDataBase : { id: app?.fbDataBase?.id }, onlyRegistered: true, item: { udn: { id: udn?.id } } }}

                onAddItem={onLinkItem}
                
                onReorderItems={onReorderItems}
            />
        }
    </>
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, 
    setForm, 
    setFilter,
    setApp,
})

export default connect(mapStateToProps, mapActionsToProps)(SuitesSection);